// extracted by mini-css-extract-plugin
export default {"image":"InternationalSiteCard_image__MDk2N"};